import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import LLmNotebook from "./Component/LLmNotebook";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<LLmNotebook />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
